const sessionTourSteps = [
  {
    target: null,
    title: "Bienvenue dans le guide de session EP",
    content:
      "Ce guide vous accompagnera pas à pas dans l'utilisation de l'interface de session d'Équipe Pluridisciplinaire. Utilisez les flèches ← → ou les boutons pour naviguer.",
  },
  {
    target: "[data-tour='header']",
    title: "En-tête de session",
    content:
      "Ici se trouvent les informations principales de la session ainsi que les boutons d'action : revenir à l'appel et clôturer la session lorsque toutes les décisions sont prises.",
  },
  {
    target: "[data-tour='info-bar']",
    title: "Informations de la session",
    content:
      "Cette barre affiche la date, le secteur, le président et le secrétaire de séance. Cliquez sur le président ou le secrétaire pour modifier les rôles (si vous avez les droits).",
  },
  {
    target: "[data-tour='stats-bar']",
    title: "Statistiques en temps réel",
    content:
      "Suivez l'avancement de la session : nombre total d'allocataires, décisions prises, suspensions et suppressions. Cliquez sur une carte pour filtrer la liste.",
  },
  {
    target: "[data-tour='filters']",
    title: "Filtres et recherche",
    content:
      "Utilisez les filtres pour affiner la liste des allocataires par type, détection, présence, décision, etc. La barre de recherche permet de trouver un allocataire par nom.",
  },
  {
    target: "[data-tour='actions-bar']",
    title: "Actions en masse",
    content:
      "Sélectionnez plusieurs allocataires puis utilisez ce bandeau pour valider les propositions en masse. La case \"Tout sélectionner\" ne sélectionne que les entrées filtrées.",
  },
  {
    target: "[data-tour='inscriptions-table']",
    title: "Liste des allocataires",
    content:
      "Chaque carte représente un allocataire inscrit à la session. Vous y retrouvez les informations principales, le contexte de saisine et la décision. Cliquez sur la carte pour ouvrir la prise de décision.",
  },
  {
    target: null,
    title: "Prise de décision",
    content:
      "En cliquant sur un allocataire, une modale s'ouvre pour saisir ou modifier la décision EP. Une fois toutes les décisions prises, le président pourra clôturer la session pour transmission au directeur.",
  },
  {
    target: null,
    title: "Guide terminé !",
    content:
      "Vous connaissez maintenant les bases de l'interface de session EP. N'hésitez pas à relancer ce guide à tout moment via le bouton tutoriel dans l'en-tête. Bonne session !",
  },
];

export default sessionTourSteps;
